export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

export const validateEmail = (email: string): string => {
    if (!email.trim()) return 'Email is required';
    if (!emailRegex.test(email)) return 'Invalid email address';
    return '';
};

export const validatePassword = (password: string): string => {
    if (!password.trim()) return 'Password required';
    if (!/[A-Z]/.test(password)) return 'Add uppercase';
    if (!/[a-z]/.test(password)) return 'Add lowercase';
    if (!/\d/.test(password)) return 'Add number';
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/.test(password)) return 'Add special char';
    if (password.trim().length < 8) return 'Min 8 chars';
    return '';
};

export const validateConfirmPassword = (confirmPassword: string, password: string): string => {
    if (!confirmPassword.trim()) return 'Confirm Password is required';
    if (confirmPassword !== password) return 'Passwords do not match';
    return '';
};

export const validateUsername = (username: string): string => {
    if (!username.trim()) return 'Username is required';
    if (username.trim().length < 3) return 'Username must be at least 3 characters';  
  return '';
};

export const validateMobile = (mobile: string, name: string = 'Mobile'): string => {
    if (!mobile.trim()) return `${name} is required`;
    if (!/^[6-9]/.test(mobile)) return 'Should start with 6, 7, 8, or 9';
    if (mobile.length !== 10) return 'Should be 10 digits';
    return '';
};